module.exports = "<p>userpartner works!</p>\n"